import { useContext } from 'react';
import { LeagueContext } from '../../pages';

export const useLeagueContext = () => {
  const context = useContext(LeagueContext);

  if (!context) {
    throw new Error('useLeagueContext must be used within LeagueProvider');
  }

  return context;
};
